import styled from "styled-components";

export const Path = styled.path`
    fill: ${(props) => props.color};
`;

export const Icon = styled.svg`
    fill: none;

    ${Path} {
        fill: ${(props) => props.color};
    }

    &:hover {
        ${Path} {
            fill: ${(props) => (props.hover ? props.hoverColor : props.color)};
        }
    }
`;
